module.exports = __webpack_public_path__ + "img/vehicle.adb4ef71.png";